import { SOUNDS_LIST } from "@amplio-common/vocabulary/constants";

export const categoriesMock = [
  {
    id: 1,
    name: "animals",
    sub_categories: [],
  },
  {
    id: 2,
    name: "occupations",
    sub_categories: [],
  },
  {
    id: 3,
    name: "vehicles",
    sub_categories: [
      "air vehicle",
      "land vehicle",
      "road vehicle",
      "recreation vehicle",
      "sidewalk vehicle",
      "water vehicle",
      "construction vehicle",
      "snow vehicle",
    ],
  },
  {
    id: 4,
    name: "food",
    sub_categories: [],
  },
  {
    id: 5,
    name: "classroom",
    sub_categories: [],
  },
  {
    id: 6,
    name: "verbs",
    sub_categories: [],
  },
  {
    id: 7,
    name: "body parts",
    sub_categories: [],
  },
  {
    id: 8,
    name: "clothing",
    sub_categories: [],
  },
  {
    id: 9,
    name: "musical instruments",
    sub_categories: [],
  },
  {
    id: 10,
    name: "tools",
    sub_categories: [
      "cutting tool",
      "fastening tool",
      "containing tool",
      "lifting tool",
      "opening tool",
      "smoothing tool",
      "lighting tool",
      "placing tool",
      "watering tool",
      "cutting",
      "transporting tool",
      "measuring tool",
      "gathering tool",
      "digging tool",
    ],
  },
];

export const fetchSoundsMock = () => {
  const allItems = [];
  const subGroups = [
    { label: "Manner", options: [] },
    { label: "Place", options: [] },
    { label: "Voicing", options: [] },
  ];

  const groups = [
    // manner
    { id: 1, label: "Stops", items: ["p", "b", "t", "d", "g", "k"], subGroup: "Manner" },
    { id: 2, label: "Fricatives", items: ["s", "z", "sh", "zh", "th (θ)", "th (ð)", "f", "v"], subGroup: "Manner" },
    { id: 3, label: "Sibilants", items: ["s", "z", "sh", "zh", "ch", "j"], subGroup: "Manner" },
    { id: 4, label: "Affricates", items: ["ch", "j"], subGroup: "Manner" },
    { id: 5, label: "Liquids", items: ["l", "r"], subGroup: "Manner" },
    { id: 6, label: "Glides", items: ["y", "w"], subGroup: "Manner" },
    { id: 7, label: "Nasals", items: ["m", "n", "ng"], subGroup: "Manner" },
    // place
    { id: 8, label: "Bilabials", items: ["p", "b", "m"], subGroup: "Place" },
    { id: 9, label: "Labiodentals", items: ["f", "v"], subGroup: "Place" },
    { id: 10, label: "Dentals", items: ["th (θ)", "th (ð)"], subGroup: "Place" },
    { id: 11, label: "Alveolars", items: ["t", "d", "n", "s", "z"], subGroup: "Place" },
    { id: 12, label: "Lateral", items: ["l"], subGroup: "Place" },
    { id: 13, label: "Palato-alveolars", items: ["sh", "zh", "ch", "j"], subGroup: "Place" },
    { id: 14, label: "Velars", items: ["k", "g"], subGroup: "Place" },
    { id: 15, label: "Approximants", items: ["r", "w", "y"], subGroup: "Place" },
    // voicing
    { id: 16, label: "Voiced", items: ["b", "d", "g", "z", "zh", "th (ð)", "v", "j", "l", "r", "y", "w", "m", "n", "ng"], subGroup: "Voicing" },
    { id: 17, label: "Unvoiced", items: ["p", "t", "k", "s", "sh", "th (θ)", "f", "ch"], subGroup: "Voicing" },
  ];

  groups.forEach(group => {
    group.value = `g-${group.id}`;
    group.items = group.items.map((item) => {
      const i = {
        id: `${item}_${group.id}`,
        value: `i-${item}${group.id}`,
        label: item,
        name: item,
        subGroup: group.subGroup,
        group: group.label,
      };
      allItems.push(i);
      return i;
    });
    group.itemsData = group.items;
    const singleItems = group.items.map(item => ({ ...item, label: `${item.label} (${group.label})` }));
    const relevantSubGroup = subGroups.find(subGroup => subGroup.label === group.subGroup);
    relevantSubGroup?.options?.push(...singleItems);
  });
  const options = [
    //{ label: "Groups", options: groups },// keep for future
    ...subGroups,
  ];
  return {
    groups,
    options,
    items: allItems,
  };
};


export const fetchSoundsWithoutGroups = () => {
  const allItems = [];
  const options = [];
  const groups = [];
  const subGroup = { label: "All Sounds", options: [] };
  const group = {
    id: 1,
    label: "Sound",
    items: SOUNDS_LIST,
    subGroup: "All Sounds",
  };

  group.value = "g-1";
  group.items = group.items.map((item) => {
    const i = {
      id: `${item}_g-1`,
      value: `i-${item}g-1`,
      label: item,
      name: item,
      subGroup: group.subGroup,
      group: group.label,
    };
    allItems.push(i);
    return i;
  });
  group.itemsData = group.items;
  groups.push(group);

  const singleItems = group.items.map(item => ({ ...item, label: `${item.label} (${group.label})` }));

  subGroup.options.push(...singleItems);
  options.push(subGroup);

  return {
    groups,
    options,
    items: allItems,
  };
};
